export default "__VITE_ASSET__Bb9ckTTQ__"